export default __webpack_public_path__ + "static/media/Likee.74556b1b.svg";